<template lang="pug">
  v-row.mt-12
    v-col(cols="12")
        
          v-card-title {{$t('social.list.title')}} {{ posts.length > 0 ?  `(${posts.length})` : null}}
            v-chip.ma-2(outlined x-small dense color="primary") Beta
          v-card-text.my-6
            v-row.px-0.socialElements(v-if="posts.length > 0")
              PostCard(v-for="(post, index) in posts" :key="index" :post="post")
            v-row.px-0.socialElements(v-else)
              v-col.px-0(cols="12")
                v-alert.rounded-lg(prominent='' )
                  v-row(align='center')
                    v-col.grow
                      | {{$t('social.list.notShared')}}
                    v-col.shrink
                      ShareMotionDialog(:video="video" type="depressed")

                //-v-card.pt-4.rounded-lg(flat)
                  v-card-subtitle.text-center {{$t('social.list.notShared')}}
                  v-card-actions 
                    v-spacer
                    
                    v-spacer
                

            
</template>

<script>
import urlFormat from "@/utils/urlFormat";
import date from "@/utils/date";
import PostCard from "@/components/social/PostCard";
import orderBy from "lodash.orderby";
import ShareMotionDialog from "@/components/video/ShareMotionDialog";
export default {
  name: "shared-to-social-card",
  props: ["video"],
  data() {
    return {
      subscription: null,
    };
  },
  computed: {
    posts() {
      return orderBy(this.video?.posts?.items ?? [], ["createdAt"], ["desc"]);
    },
  },
  components: {
    PostCard,
    ShareMotionDialog,
  },
  methods: {
    ...date,
    ...urlFormat,
    refreshPost(post) {
      this.$store.dispatch("socialConnection/REFRESH_POST", {
        post,
      });
    },
  },
  async mounted() {
    this.subscription = this.$store.dispatch(
      "socialConnection/LISTEN_TO_NEW_POSTS_FOR_VIDEO_ASSET",
      {
        videoAssetId: this.video.id,
      }
    );
  },
  beforeDestroy() {
    this.subscription?.unsubscribe();
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables'
</style>
